/* eslint-disable react-hooks/rules-of-hooks */
import React , { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'

import { useForm } from "react-hook-form"

import { get, put, deleteItem } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'

export default function index() {
  document.title = 'ایجاد میز'

  const navigate = useNavigate()
  const { id } = useParams()

  const [resturantSelect, setResturantSelect] = useState('')
  const [resturantSelectAlert, setResturantSelectAlert] = useState(false)
  const [resturants, setResturants] = useState([])

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')

  const shopHandler = (e) => {
    setResturantSelect(e.target.value)
  }

  useEffect(() => {
    get(`/api/admin/table/${id}?token=${token}`)
      .then(response => {
        let defaultValues = {}
        defaultValues.name = response.data.data[0].name
        reset({ ...defaultValues })
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()

    if (resturantSelect.length === 0) {
      setResturantSelectAlert(true)
    } else {
      setResturantSelectAlert(false)
      put(`/api/admin/table/${id}?token=${token}`, {
          name: data.name,
          branch: resturantSelect
        }).then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/servers')
          }, 2000)
        }).catch(error => {
          notify('error', 'خطا در ارسال اطلاعات')
        })
      }    
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/table/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/servers')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  useEffect(() => {
    get(`/api/admin/shops?token=${token}`)
      .then(response => {
        setResturants(response.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید میز مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <Menu page={'server'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد میز
              </div>
            </div>

            <div className='left'>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف میز</button>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className='form'>
            <div className='title'>
              * برای ایجاد میز جدید لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات میز‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='tableNumber'>شماره میز * :</label>
                <input id='tableNumber' {...register("name", { required: true, minLength: 3 })} type='string' />
                <small id='tableNumberAlert'>شماره میز باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * :</label>
                <select id='resturantName' {...register("shop", { 
                  onChange: (e) => {shopHandler(e)},
                    required: true })}>
                    <option id='none'>انتخاب کنید</option>
                    {resturants ? resturants.map((item, index) => {
                      return <option key={index} value={item._id}>{item.name}</option>
                    }) : ''}
                </select>
                <small id='resturantNameAlert' style={resturantSelectAlert ? { display : 'flex' } : { display: 'none' }}>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' >ویرایش میز</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
